import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import './_footer.scss';
import { Link } from 'react-router-dom';

import { getCPMapping } from '../../../CPMapping';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { showLoginModal } from 'hb-redux-store/feature/modal/modal.action';
import Icon from 'components/mweb/Icon/Icon';
import { resetPDP } from 'hb-redux-store/feature/products/product.action';
import { HALALBOX_INDIA_CC_NUMBER } from 'hb-redux-store/util/constantServices';

const Footer = ({ setAppNotification, showLoginModal, pdp, h1, resetPDP }) => {
  const COMPANY_DETAILS = [
    {
      menu: 'Company',
      submenu: [
        { key: 'Blog', url: '/blogs' },
        { key: 'About Us', url: '/' },
      ],
    },
    {
      menu: 'Profile',
      submenu: [
        isLoggedInUser() && { key: 'My Account', url: '/my/details' },
        !isLoggedInUser() && { key: 'Login', url: '#' },
        isLoggedInUser() && { key: 'Refer & Earn', url: '/my/referrals' },
      ],
    },
    {
      menu: 'Need Help',
      submenu: [
        { key: 'Browse Fruits', url: '/fruits' },
        { key: 'Browse Vegetables', url: '/vegetables' },
        { key: 'Browse Dry Fruits', url: '/dryfruits' },
        { key: 'FAQs', url: '/help/faqs' },
      ],
    },
    {
      menu: 'Policy Info',
      submenu: [
        // { key: 'Editorial Policy', url: '/' },
        { key: 'Privacy Policy', url: '/help/privacy-policy' },
        { key: 'Terms & Condition', url: '/help/tnc' },
      ],
    },
  ];

  const productsDetails = () => {
    const categories = getCPMapping().categories.sort(
        (a, b) => a.categoryId - b.categoryId
      ),
      products = getCPMapping().products.sort(
        (a, b) => a.categoryId - b.categoryId
      );
    let products_details = [],
      submenu = [];
    categories.map(item1 => {
      submenu = [];
      products.map(item2 => {
        if (
          item1.categoryId === item2.categoryId &&
          !item2.productDisplayName.includes('TAS') &&
          !item2.productDisplayName.includes('TEST')
        ) {
          submenu.push({
            key: item2.productDisplayName,
            url: `/${item2.categorySeoName}/${item2.productSeoName}`,
          });
        } else {
          const isExists = products_details.some(
            el => el.menu === item1.categorySeoName
          );
          !isExists &&
            products_details.push({ menu: item1.categorySeoName, submenu });
        }
      });
    });
    return products_details;
  };

  const officeAddress = () => {
    return (
      <div className="desktop-footer--office-address">
        <div className="desktop-footer--menu-title">Office Address:</div>
        <ul>
          <li key="1">WeWork, 10th Floor,</li>
          <li key="2">Tower 1, Seawoods, Navi Mumbai,</li>
          <li key="3">Maharashtra, 400706</li>
        </ul>
      </div>
    );
  };

  const getServiceLocation = () => {
    return (
      <Fragment>
        <div className="desktop-footer--menu-title">Serving Location:</div>
        <div className="desktop-footer-menu-list--li">
          We are currently serving in Dadar, Mahim, Matunga, Worli,
          Prabhadevi,Shivaji Park, Bandra East, Bandra West, Khar East, Khar
          West, Santacruz East , Santacruz West ,Andheri East, Andheri West,
          Juhu, Ville Parle, Vakola, Mumbai Central, Tardeo, Cumbala Hills,
          Worli SeaFace, Sion, Dharavi, Parel, Lower Parel, Mahalaxmi, Haji ALi,
          Walkeshwar, Nagpada,Madanpura,etc
        </div>
      </Fragment>
    );
  };

  const getContent = () => {
    return (
      <Fragment>
        <div>
          <h1 className="desktop-footer--menu-heading desktop-footer--bottom">
            Buy Grade A quality Fruits, Nuts, Vegetables Online at VegXL
          </h1>
        </div>
        <h2 className="desktop-footer--menu-title desktop-footer--bottom">
          Buy Exotic Fruits Online in Mumbai
        </h2>
        <div className="desktop-footer-menu-list--li">
          <p>
            Indulge in a tantalizing assortment of exotic fruits available at
            VegXL, your ultimate destination for premium quality produce.
            Sourced from the finest origins, our exotic fruits are a testament
            to nature's bounty at its best. Each bite unveils a symphony of
            flavors and textures, transporting you to distant tropical
            landscapes.
          </p>{' '}
          <p>
            At VegXL, we take pride in curating an exclusive selection of exotic
            fruits that are unparalleled in their quality and taste. From the
            vibrant hues of dragon fruit to the velvety richness of mango
            varieties like Alphonso and Kesar, our collection showcases nature's
            artistic prowess. Whether it's the zesty intrigue of kiwifruit or
            the luxurious sweetness of lychee, our fruits are meticulously
            handpicked at the peak of ripeness.
          </p>{' '}
          <p>
            Elevate your culinary experience with the uniqueness of carambola
            (star fruit), the buttery smoothness of avocado, and the refreshing
            notes of passion fruit. As your trusted source for excellence, VegXL
            ensures that each exotic fruit is delivered with care to your
            doorstep, maintaining its freshness and nutritional value.
          </p>{' '}
          <p>
            Explore the world of exotic fruits with VegXL and embark on a
            journey of flavors that transcend borders. With competitive prices
            and early morning delivery, we invite you to savor these
            extraordinary fruits that redefine gastronomic delight.
          </p>{' '}
          <h2 className="desktop-footer--menu-title desktop-footer--bottom">
            Buy Grade A quality dry fruits in Mumbai
          </h2>
          <p>
            Discover the epitome of nourishment and taste with VegXL's exquisite
            range of Grade A quality dry fruits. Elevate your snacking
            experience with our premium selection, where each bite is a blend of
            health and indulgence. Sourced for their superior quality, our dry
            fruits boast rich flavors and essential nutrients.
          </p>{' '}
          <p>
            VegXL takes pride in offering you the finest assortment of almonds,
            cashews, pistachios, and more. Each dry fruit is meticulously graded
            to ensure you receive the highest standard. With reasonable rates
            and top-notch quality, we bring you the perfect companions for your
            busy lifestyle. Revitalize your energy and enjoy the goodness of
            nature's bounty with VegXL's Grade A quality dry fruits.
          </p>{' '}
          <h2 className="desktop-footer--menu-title desktop-footer--bottom">
            Buy Superior Quality Vegetables Online in Mumbai
          </h2>
          <p>
            Experience the true essence of health with VegXL's range of premium
            organic vegetables. Cultivated with care and free from harmful
            chemicals, our organic veggies are a testament to nature's purity.
            Dive into a world of vibrant flavors and wholesome goodness, knowing
            that you're nourishing your body and the environment.
          </p>{' '}
          <p>
            VegXL takes pride in offering a diverse selection of organic
            vegetables, from crisp greens to colorful bell peppers and more. Our
            commitment to quality ensures that you receive produce that's not
            only delicious but also packed with essential nutrients. Embrace a
            lifestyle of wellness with VegXL's organic vegetables, where every
            bite is a step towards a greener, healthier future.
          </p>{' '}
        </div>
      </Fragment>
    );
  };
  const onSelect = key => {
    if (key === 'Login') {
      setAppNotification('Please login');
      setTimeout(() => {
        showLoginModal(true);
      }, 1200);
    }
    if (pdp && h1 && resetPDP) resetPDP();
  };
  const renderAppLinks = () => {
    const downloadLink = 'https://onelink.to/7yd7rd';
    const playStoreLink = '#';
    // 'https://play.google.com/store/apps/details?id=in.halalboxapp';
    const appStoreLink = '#'; // 'https://apps.apple.com/in/app/halalbox/id1524189088';
    const appGalleryLink = '#'; //'https://appgallery.huawei.com/app/C104767385';
    // src="https://ik.imagekit.io/iwcam3r8ka/prod/emails/202111/b8007d73-1fdb-421d-8f02-cb3d92c64d4a.jpg"
    const hbIllustrationImage =
      'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202007/6b963365-ca9d-476e-aac9-4676823fde3d.png';
    const vxlImage =
      // 'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202309/a6bf1e9c-b02b-4b2f-9c42-306df125d020.jpg';
      'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202309/e06c05d3-c7f1-475a-87d9-9f491e959185.png';
    return (
      <div className="desktop-footer-image">
        <div className="desktop-footer-image--content-main">
          <div className="desktop-footer-image--illustration">
            <img src={vxlImage} alt="VegXL App" />
          </div>
          <div className="desktop-footer-image--download">
            <div className="desktop-footer-image--download--title">
              Download the app
            </div>
            <div>
              <div className="desktop-footer-image--download--links android">
                <a href={playStoreLink}>
                  <img
                    src="https://ik.imagekit.io/iwcam3r8ka/prod/vxl-email/202309/1507ce01-35fb-4bb3-9ad1-0b3cf1879f1d.svg"
                    alt="download from play store"
                  />
                </a>
              </div>
              <div className="desktop-footer-image--download--links ios">
                <a href={appStoreLink}>
                  <img
                    src="https://ik.imagekit.io/iwcam3r8ka/prod/vxl-email/202309/1088775d-6820-4b4b-9be4-aff7cd603259.svg"
                    alt="download from app store"
                  />
                </a>
              </div>
              <div className="desktop-footer-image--download--links huawei">
                <a href={appGalleryLink}>
                  <img
                    src="https://ik.imagekit.io/iwcam3r8ka/prod/vxl-email/202309/dbebb90f-f638-482f-86e7-ac5f14fdd8b1.svg"
                    alt="download from huawei app gallery"
                  />
                </a>
              </div>
            </div>
            <div className="desktop-footer-image--content-body">
              <b>
                Any concern / feedback while placing the order or delivery, you
                can connect with us at
              </b>
              <br />
              <br />
              <div className="justify-content--space-between">
                <div className="justify-content--space-between">
                  <Icon size={22} class="icon-customer-care" />
                  <span className="desktop-footer-image--span">
                    Customer Support: <b>+91-{HALALBOX_INDIA_CC_NUMBER}</b>
                  </span>
                </div>
                <div className="justify-content--space-between">
                  <Icon size={22} class="icon-gmail" />
                  <span className="desktop-footer-image--span">
                    {' '}
                    Email: <b>care@vegxl.in</b>
                  </span>
                </div>
              </div>
            </div>
            <div className="desktop-footer-image--content-body desktop-footer-image--insta-fb ">
              <div>
                <b>For all our latest updates, follow us on</b>
              </div>
              <div className="desktop-footer-image--insta-fb--margin">
                <a
                  href="https://www.facebook.com/vegxlofficial"
                  target="_blank"
                >
                  <Icon
                    size={30}
                    class="icon-facebook desktop-footer-image--insta-fb--icon"
                  />
                </a>
                <a
                  href="https://www.instagram.com/vegxlofficial"
                  target="_blank"
                >
                  <Icon size={30} class="icon-instagram" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCompany = (data, isOfficeAddress) => {
    return (
      <div className="desktop-footer-menu-list">
        {data.map((item, index) => {
          return (
            <div key={`${index}-submenu`}>
              <div className="desktop-footer--menu-title">{item.menu}</div>
              <ul key={`ul-${item.menu}-${index}`}>
                {item.submenu &&
                  item.submenu.map((submenu, subMenuIndex) => (
                    <li key={`li-${submenu.key}-${subMenuIndex}`}>
                      <Link
                        to={`${submenu.url}`}
                        className="desktop-footer-menu-list--li"
                        onClick={() => onSelect(submenu.key)}
                        title={submenu.key}
                      >
                        {submenu.key}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          );
        })}
        {isOfficeAddress && officeAddress()}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="section-divider"></div>
      {renderAppLinks()}
      <div className="desktop-footer">
        <div className="desktop-footer-section-divider"></div>
        {renderCompany(COMPANY_DETAILS, true)}
        <div className="desktop-footer-section-divider"></div>
        {pdp && h1 && (
          <div>
            <h1 className="desktop-footer--menu-heading desktop-footer--bottom">
              {h1}
            </h1>
          </div>
        )}
        {productsDetails() && renderCompany(productsDetails())}
        <div className="desktop-footer-section-divider"></div>
        {!pdp && (
          <React.Fragment>
            {getServiceLocation()}
            <div className="desktop-footer-section-divider" />
            {getContent()}
            <div className="desktop-footer-section-divider" />
          </React.Fragment>
        )}
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = {
  setAppNotification,
  showLoginModal,
  resetPDP,
};

export default connect(null, mapDispatchToProps)(Footer);
